import { iconButtonClasses } from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';

import { deepNavy } from '../../palette-v2';

// ----------------------------------------------------------------------
// V2 Design System — IconButton
//
// There was no override at all, in v1 or v2, for ~60 call sites: raw MUI hover
// tints and no size relationship to Button. Sizes mirror the Button scale
// (32/38/46) so an icon button sitting next to a button lines up.
// ----------------------------------------------------------------------

export function iconButtonV2(theme: Theme) {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          color: deepNavy[900],
          '&:hover': {
            backgroundColor: deepNavy[100],
          },
          [`&.${iconButtonClasses.disabled}`]: {
            color: deepNavy[300],
          },
        },
        sizeSmall: {
          width: 32,
          height: 32,
        },
        sizeMedium: {
          width: 38,
          height: 38,
        },
        sizeLarge: {
          width: 46,
          height: 46,
        },
      },
    },
  };
}
